import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material';
import { handleImageClick } from '../../../utils/imageUtils';

// Import all 31 wall cladding stone images
import wall1 from "../../../assets/images/Wall Cladding Stone1.jpeg";
import wall2 from "../../../assets/images/Wall Cladding Stone2.jpeg";
import wall3 from "../../../assets/images/Wall Cladding Stone3.jpeg";
import wall4 from "../../../assets/images/Wall Cladding Stone4.jpeg";
import wall5 from "../../../assets/images/Wall Cladding Stone5.jpeg";
import wall6 from "../../../assets/images/Wall Cladding Stone6.jpeg";
import wall7 from "../../../assets/images/Wall Cladding Stone7.jpeg";
import wall8 from "../../../assets/images/Wall Cladding Stone8.jpeg";
import wall9 from "../../../assets/images/Wall Cladding Stone9.jpeg";
import wall10 from "../../../assets/images/Wall Cladding Stone10.jpeg";
import wall11 from "../../../assets/images/Wall Cladding Stone11.jpeg";
import wall12 from "../../../assets/images/Wall Cladding Stone12.jpeg";
import wall13 from "../../../assets/images/Wall Cladding Stone13.jpeg";
import wall14 from "../../../assets/images/Wall Cladding Stone14.jpeg";
import wall15 from "../../../assets/images/Wall Cladding Stone15.jpeg";
import wall16 from "../../../assets/images/Wall Cladding Stone16.jpeg";
import wall17 from "../../../assets/images/Wall Cladding Stone17.jpeg";
import wall18 from "../../../assets/images/Wall Cladding Stone18.jpeg";
import wall19 from "../../../assets/images/Wall Cladding Stone19.jpeg";
import wall20 from "../../../assets/images/Wall Cladding Stone20.jpeg";
import wall21 from "../../../assets/images/Wall Cladding Stone21.jpeg";
import wall22 from "../../../assets/images/Wall Cladding Stone22.jpeg";
import wall23 from "../../../assets/images/Wall Cladding Stone23.jpeg";
import wall24 from "../../../assets/images/Wall Cladding Stone24.jpeg";
import wall25 from "../../../assets/images/Wall Cladding Stone25.jpeg";
import wall26 from "../../../assets/images/Wall Cladding Stone26.jpeg";
import wall27 from "../../../assets/images/Wall Cladding Stone27.jpeg";
import wall28 from "../../../assets/images/Wall Cladding Stone28.jpeg";
import wall29 from "../../../assets/images/Wall Cladding Stone29.jpeg";
import wall30 from "../../../assets/images/Wall Cladding Stone30.jpeg";
import wall31 from "../../../assets/images/Wall Cladding Stone31.jpeg";

// Create array of all images
const wallCladdingImages = [
    wall1, wall2, wall3, wall4, wall5, wall6, wall7, wall8, wall9, wall10,
    wall11, wall12, wall13, wall14, wall15, wall16, wall17, wall18, wall19, wall20,
    wall21, wall22, wall23, wall24, wall25, wall26, wall27, wall28, wall29, wall30,
    wall31
];

const WallCladding = () => {
    return (
        <Box>
            <InnerPageBanner title="Wall Cladding" image={wall30} />
            <Container sx={{ py: 5 }}>

                <Box sx={{
                    backgroundColor: "#f5f5f5",
                    py: { xs: 4, md: 6 },
                    px: { xs: 2, md: 4 },
                    borderRadius: 2
                }}>
                    {/* ===== Top Hero Section ===== */}
                    <Box
                        sx={{
                            backgroundColor: "#eaeaea",
                            p: { xs: 3, sm: 5, md: 8 },
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                        >
                            No Doubt We Are Trusted
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 24, sm: 28, md: 36 }
                            }}
                        >
                            Wall Cladding
                        </Typography>

                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                my: 2
                            }}
                        />

                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ fontSize: { xs: 13, md: 14 } }}>
                                <strong>Available Color</strong><br />
                                Grey (White)<br />
                                Jet Black<br />
                                Yellow<br />
                                Pink (Red)
                            </Typography>
                        </Box>
                    </Box>

                    {/* ===== Image Gallery Section ===== */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 3,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Wall Cladding Varieties
                    </Typography>

                    <Box sx={{ width: 40, height: 3, backgroundColor: "#1abc9c", mb: 4 }} />

                    <Grid container spacing={4}>
                        {/* All 31 Images in Grid */}
                        {wallCladdingImages.map((image, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`Wall Cladding ${index + 1}`}
                                    onClick={() => handleImageClick(image)}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, sm: 220, md: 250 },
                                        objectFit: "cover",
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                                        }
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default WallCladding;